import CTABanner from "components/DynamicComponent/atoms/CTABanner"
import Meta from "components/Meta"
import Map from "components/Map"
import LocationLinks from "components/DynamicComponent/molecules/LocationLinks"
import { getGlobals, getAllLocationItems, getLocationArchive } from "storyblok/api"
import richText from "utilities/richText"
import StoryblokVisualEditor from "components/StoryblokVisualEditor"

export default function LocationArchive({ locations, story }) {
  const description =
    "We proudly serve patients throughout the Greater Phoenix, Arizona area. Use our interactive map or review our locations list to find the best location for you!"

  return (
    <>
      <Meta
        info={{
          title: "Office/Clinic Locations | Sonoran Spine",
          og_title: "Office/Clinic Locations | Sonoran Spine",
          twitter_title: "Office/Clinic Locations | Sonoran Spine",
          description: description,
          og_description: description,
          twitter_description: description,
        }}
      />
      <main>
        <section className="relative h-52 lg:h-[545px] w-full basis-full">
          <Map initialZoom={6.5} locations={locations} scrollToZoom={false} />
        </section>
        <StoryblokVisualEditor story={story?.content}>
          <section className="px-8 pt-12 max-w-screen-xl mx-auto">
            <h1 className="text-l1 lg:text-l2">{story?.content?.heading}</h1>
            <div className="max-w-3xl prose-p:font-light">{richText(story?.content?.content)}</div>
          </section>
        </StoryblokVisualEditor>

        <LocationLinks blok={{ locations }} />
      </main>
      <CTABanner />
    </>
  )
}

export async function getStaticProps({ preview = null }) {
  const globals = await getGlobals()
  const locations = await getAllLocationItems()
  const story = await getLocationArchive(preview)

  return {
    props: {
      globals: globals ?? null,
      locations,
      story: story ?? null,
      preview,
    },
  }
}
